// Quote Builder — bottom toolbar.
//
// Checklist / T&Cs / Approval. Templates, Scanner, Bulk width and Dimensions
// were removed to declutter the toolbar; Payments was removed too (wiring it
// touches Stripe / commission paths). Real implementations port the
// source-of-truth kos-qb-v3.js handlers verbatim where business logic permits.

import { iconMarkup, type IconName } from "@tkos/shared-ui";
import type { QuoteStore } from "./state";
import type { PageContext } from "../../shell/types";
import { escapeHtml } from "./formatters";
import { openTandCsModal, openChecklistModal, openApprovalModal } from "./toolbar-modals";

type ToolId = "checklist" | "tandcs" | "approval";

const TOOLS: ReadonlyArray<{ id: ToolId; label: string; icon: IconName; stubbed: boolean }> = [
  { id: "checklist", label: "Checklist",   icon: "check",     stubbed: false },
  { id: "tandcs",    label: "T&Cs",        icon: "file",      stubbed: false },
  { id: "approval",  label: "Approval",    icon: "signature", stubbed: false },
];

export function mountToolbar(host: HTMLElement, store: QuoteStore, ctx: PageContext): () => void {
  host.innerHTML = `
    <nav class="qb-toolbar" aria-label="Quote tools">
      ${TOOLS.map((t) => `
        <button type="button" class="qb-tool" data-tool="${escapeHtml(t.id)}" ${t.stubbed ? 'data-stub="1"' : ""}>
          <span class="qb-tool__icon" aria-hidden="true">${iconMarkup(t.icon, { size: "sm" })}</span>
          <span class="qb-tool__label">${escapeHtml(t.label)}</span>
        </button>
      `).join("")}
    </nav>
  `;

  host.querySelectorAll<HTMLButtonElement>(".qb-tool").forEach((btn) => {
    btn.addEventListener("click", () => {
      const id = btn.dataset.tool as ToolId;
      handleTool(id);
    });
  });

  function handleTool(id: ToolId): void {
    switch (id) {
      case "tandcs":
        openTandCsModal(store, ctx);
        break;
      case "checklist":
        openChecklistModal(store, ctx);
        break;
      case "approval":
        openApprovalModal(store, ctx);
        break;
    }
  }

  return () => {
    /* no document-level listeners */
  };
}
